import isSameDay from 'date-fns/isSameDay';
import isDate from 'date-fns/isDate';

export default function isNotInHoliday(officialHoliday: Array<Date>, pickMealTime: Date | null) {
  if (!pickMealTime || !isDate(pickMealTime)) {
    return false;
  }
  return !(officialHoliday || []).some((date) => isSameDay(date, pickMealTime));
}
